import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

function MockQuestionBookCard(props) {
  const { mockQuestionBook } = props;

  return (
    <div className="relative mb-5 cursor-default gap-2.5 rounded-lg border border-primary-lightest bg-white p-4 shadow-dropshadow-sm transition duration-150">
      <h1 className="mb-2 text-2xl font-extrabold leading-tight text-primary">{mockQuestionBook?.title}</h1>
      <p className="mb-4">Responda ao simulado agora e desbloqueie seu plano de estudos personalizado! Não deixe para depois, seu futuro espera!</p>

      <Button
        variant="outline"
        size="sm"
        asChild
      >
        <Link
          to={`/simulados/sobre/${mockQuestionBook?.id}`}
          title="Mais detalhes"
        >
          Mais detalhes
        </Link>
      </Button>
    </div>
  );
}

export default MockQuestionBookCard;
